<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title text-center">工單履歷</div>
      <template v-if="detail == false">
        <workOrderHistoryQuery></workOrderHistoryQuery>
      </template>
      <template v-else>
        <workOrderHistoryDetail></workOrderHistoryDetail>
      </template>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import workOrderHistoryQuery from "@/components/workOrderHistory/workOrderHistoryQuery.vue";
import workOrderHistoryDetail from "@/components/workOrderHistory/workOrderHistoryDetail.vue";
import { ref } from "@vue/reactivity";
import { provide } from "@vue/runtime-core";

export default {
  components: {
    workOrderHistoryQuery,
    workOrderHistoryDetail,
  },
  setup() {
    const wip_lot = ref();
    const detail = ref(false);
    const completeWorkItems = ref([]);
    provide("wip_lot", wip_lot);
    provide("detail", detail);
    provide("completeWorkItems", completeWorkItems);

    return {
      detail,
    };
  },
};
</script>

<style scoped></style>
